import { useParams } from "react-router-dom";
import ChangePageTitle from "../components/change-title-page";
import SingleBlog from "../components/components-single-blog";
import { useBlog } from "../hooks/apis/blog";

function Post_blog() {
  const { post_id } = useParams();
  const { data, isLoading, error } = useBlog(post_id);

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error</p>;

  return (
    <>
      <ChangePageTitle pageTitle={`${data?.title} | رستوران باغبان`} />
      <SingleBlog data={data} />
    </>
  );
}

export default Post_blog;
